import { createContext, type Context } from 'react';

export type ActionGroupContextProps = {
  /**
   * Whether or not the ActionGroup is collapsed.
   * @defaultValue false
   */
  isCollapsed: boolean;
};

/**
 * ActionGroup context, used to access the state of the ActionGroup in other components.
 */
export const ActionGroupContext: Context<ActionGroupContextProps> =
  createContext<ActionGroupContextProps>({
    isCollapsed: false,
  });
ActionGroupContext.displayName = 'ActionGroupContext';
